// ----------------------------------------------------------------------
// Tabs: selected = secondary blue text + underline.
// Non-active: identical look at rest and on hover/focus (no UI change).
// ----------------------------------------------------------------------

export default function Tabs(theme) {
  const secondary = theme.palette.secondary.main;
  const idle = theme.palette.text.secondary;
  const badgeBg = theme.palette.grey[100];
  const badgeFg = theme.palette.grey[600];

  const tabRoot = {
    textTransform: "none",
    fontWeight: 600,
    minHeight: 48,
    backgroundColor: "transparent !important",
    color: idle,
    opacity: 1,
    transition: "none !important",
    WebkitTapHighlightColor: "transparent",
    // Idle icons match label (avoid SvgIcon action.active → hover flip)
    "&:not(.Mui-selected) .MuiSvgIcon-root, &:not(.Mui-selected) svg": {
      color: `${idle} !important`,
      fill: `${idle} !important`,
    },
    "&:not(.Mui-selected) .icp-tab-count-badge": {
      backgroundColor: `${badgeBg} !important`,
      color: `${badgeFg} !important`,
    },
    "&:hover, &:focus, &:active, &.Mui-focusVisible": {
      backgroundColor: "transparent !important",
      boxShadow: "none !important",
      opacity: 1,
    },
    "&:hover:not(.Mui-selected), &:focus:not(.Mui-selected), &:active:not(.Mui-selected)":
      {
        backgroundColor: "transparent !important",
        color: `${idle} !important`,
        boxShadow: "none !important",
        filter: "none !important",
        transform: "none !important",
      },
    "&:hover:not(.Mui-selected) .MuiSvgIcon-root, &:hover:not(.Mui-selected) svg, &:focus:not(.Mui-selected) .MuiSvgIcon-root, &:focus:not(.Mui-selected) svg":
      {
        color: `${idle} !important`,
        fill: `${idle} !important`,
      },
    "&:hover:not(.Mui-selected) .icp-tab-count-badge, &:focus:not(.Mui-selected) .icp-tab-count-badge":
      {
        backgroundColor: `${badgeBg} !important`,
        color: `${badgeFg} !important`,
      },
    "& .MuiTouchRipple-root": {
      display: "none",
    },
    "&.Mui-selected": {
      color: `${secondary} !important`,
      backgroundColor: "transparent !important",
      fontWeight: 700,
      opacity: 1,
    },
    "&.Mui-selected:hover, &.Mui-selected:focus, &.Mui-selected:active, &.Mui-selected.Mui-focusVisible":
      {
        backgroundColor: "transparent !important",
        color: `${secondary} !important`,
        boxShadow: "none !important",
      },
    "&.Mui-disabled": {
      opacity: 0.4,
    },
    "&.Mui-selected .MuiSvgIcon-root, &.Mui-selected svg": {
      color: `${secondary} !important`,
      fill: `${secondary} !important`,
    },
    "&.Mui-selected .icp-tab-count-badge": {
      backgroundColor: `${secondary} !important`,
      color: `${theme.palette.common.white} !important`,
    },
  };

  const tabsRoot = {
    backgroundColor: "transparent",
    minHeight: 48,
  };

  const indicator = {
    backgroundColor: `${secondary} !important`,
    height: 3,
    borderRadius: 2,
  };

  const textColorIdle = {
    color: idle,
    "&:hover, &:focus, &:active": {
      color: `${idle} !important`,
    },
    "&.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus": {
      color: `${secondary} !important`,
    },
  };

  return {
    MuiTabs: {
      defaultProps: {
        textColor: "secondary",
        indicatorColor: "secondary",
      },
      styleOverrides: {
        root: tabsRoot,
        indicator,
        flexContainer: {
          backgroundColor: "transparent",
        },
      },
    },
    MuiTabList: {
      defaultProps: {
        textColor: "secondary",
        indicatorColor: "secondary",
      },
      styleOverrides: {
        root: tabsRoot,
        indicator,
      },
    },
    MuiTab: {
      defaultProps: {
        disableRipple: true,
        disableFocusRipple: true,
        disableTouchRipple: true,
      },
      styleOverrides: {
        root: tabRoot,
        textColorSecondary: textColorIdle,
        textColorPrimary: textColorIdle,
        iconWrapper: {
          transition: "none",
          color: "inherit",
        },
      },
    },
  };
}
